import { instanceOfGrid } from "../grid/instanceOfGrid.js";
function findConstructorItemByCondition(constructor, condition) {
  if (condition(constructor)) {
    return constructor;
  }
  for (const item of constructor.items) {
    if (instanceOfGrid(item)) {
      const foundItem = findConstructorItemByCondition(item, condition);
      if (foundItem) {
        return foundItem;
      }
    } else if (condition(item)) {
      return item;
    }
  }
}
export {
  findConstructorItemByCondition
};
